<template>
  <BaseTooltip
    :text="tooltipText"
    position="top"
    :disabled="!tooltip"
  >
    <span
      class="base-sequence-badge"
      :class="{ 'base-sequence-badge--filled': filled }"
      tabindex="0"
    >
      {{ value }}
    </span>
  </BaseTooltip>
</template>

<script>
export default {
  name: "BaseSequenceBadge",

  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    filledTooltipText: {
      type: String,
      default: "Обязательные поля заполнены",
    },
    emptyTooltipText: {
      type: String,
      default: "Заполните обязательные поля",
    },
  },

  computed: {
    tooltipText() {
      return this.filled ? this.filledTooltipText : this.emptyTooltipText;
    },
  },
};
</script>

<style scoped>
.base-sequence-badge {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--color-yellow);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  transition: background-color 0.2s ease;
}

.base-sequence-badge--filled {
  background: var(--color-green);
}
</style>
